import { Component, OnInit, OnDestroy } from '@angular/core';
import { DataService} from "src/app/services/data.service";
import {observable} from 'rxjs'

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
})
export class CartComponent implements OnInit {
  total = 0;
  // shoppingList: Array<ShoppingListItem> = [];

  constructor(public dataService: DataService) { }

  ngOnInit() { 
    console.log(this.dataService.cart)
    this.dataService.getShoppingList();
  }
removeFromCart() {
  this.dataService.clearCart();
}

}
